import { ref } from "vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../../store/TaikyoStore";
const log = Log.create("Kaiyaku.load");
export const useLoad = () => {
    const loading = ref(false);
    const load = async () => {
        try {
            loading.value = true;
            await store.loadForKaiyaku();
            await store.loadHasonInfo();
        }
        catch (ex) {
            log.error("load", ex);
            if (ex.status !== 404) {
                MsgBox.error(ex.message);
            }
        }
        finally {
            loading.value = false;
        }
    };
    return {
        loading,
        load
    };
};
